import * as React from 'react';
import { capitalize, clamp } from 'lodash';

interface IStackedProgressBarProps {
	/**
	 * number of completed units
	 */
	completed: number,
	/**
	 * number of selected units, inclusive of completed units
	 */
	selected: number,
	/**
	 * total number of units
	 */
	totalRequired: number,
}

const convertToPercentage = (ratio: number) => clamp(ratio * 100, 0, 100);

/**
 * Presents a progress bar respresenting program unit progress
 */
export default function StackedProgressBar(props: IStackedProgressBarProps) {
	const {
		completed, selected, totalRequired,
	} = props;

	const completedPercent = convertToPercentage(completed / totalRequired);
	const selectedPercent = convertToPercentage((selected + completed) / totalRequired);

	return (
		<div className="stacked-progress-bar">
			<div className="bar">
				<div className="completed" style={{ width: `${completedPercent}%` }} />
				<div className="selected" style={{ width: `${selectedPercent}%` }} />
				<div className="required-courses" />
			</div>
			<div className="label">
				<span className="title">Overall Progress</span>
				<span className="key">
					<span className="icon icon-left icon-circle-fill completed">{window.lexicon.completedCredit}</span>
					<span className="icon icon-left icon-circle-fill selected">Selected</span>
					<span className="icon icon-left icon-circle-fill required-courses">Required</span>
				</span>
			</div>
		</div>
	);
}
